<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="left_nav">
          leftNav
        </div>
        <div class="right_con">
          right
        </div>
      </div>
    </div>
  </div>
              <!-- <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
              <el-tab-pane
                label="待付款"
                name="1"
                v-infinite-scroll="load"
                infinite-scroll-disabled="disabled"
              >
                <div class="order_item">
                  <div class="item_title">
                    <i>订单号：2021083100011174</i>
                    <em>交易完成</em>
                  </div>
                  <ul class="item_body">
                    <li class="td1">
                      <img class="body_img" src="" alt="" />
                      <div class="body_con">
                        <div class="con_title">
                          九阳电饭锅1L3L5L电饭煲小型宿舍家用2人迷你多功能
                          全自动大容量
                        </div>
                        <div class="con_ge">
                          <i>颜色：棕色</i>
                          <em>规格：1-2人用小饭煲(机械型)</em>
                        </div>
                      </div>
                    </li>
                    <li class="td2">￥798.00</li>
                    <li class="td3">×2</li>
                  </ul>
                  <div class="item_bottom">
                    <div class="order_time">
                      <i>交易时间：2021-09-09 09:04:21</i>
                    </div>
                    <div class="order_state">
                      <div class="order_text">共2件商品，实付金额：</div>
                      <div class="order_money">￥798.00</div>
                    </div>
                  </div>
                </div>

                <div class="order_load">
                  <div class="" v-if="loading">加载中...</div>
                  <div class="" v-if="noMore">没有更多了</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="待发货" name="2">
                <div class="order_item">
                  <div class="item_title">
                    <i>订单号：2021083100011174</i>
                    <em>待发货</em>
                  </div>
                  <ul class="item_body">
                    <li class="td1">
                      <img class="body_img" src="" alt="" />
                      <div class="body_con">
                        <div class="con_title">
                          九阳电饭锅1L3L5L电饭煲小型宿舍家用2人迷你多功能
                          全自动大容量
                        </div>
                        <div class="con_ge">
                          <i>颜色：棕色</i>
                          <em>规格：1-2人用小饭煲(机械型)</em>
                        </div>
                      </div>
                    </li>
                    <li class="td2">￥798.00</li>
                    <li class="td3">×2</li>
                  </ul>
                  <div class="item_bottom">
                    <div class="order_time">
                      <i>交易时间：2021-09-09 09:04:21</i>
                    </div>
                    <div class="order_state">
                      <div class="order_text">共2件商品，实付金额：</div>
                      <div class="order_money">￥798.00</div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="待收货" name="3">
                <div class="order_item">
                  <div class="item_title">
                    <i>订单号：2021083100011174</i>
                    <em>待收货</em>
                  </div>
                  <ul class="item_body">
                    <li class="td1">
                      <img class="body_img" src="" alt="" />
                      <div class="body_con">
                        <div class="con_title">
                          九阳电饭锅1L3L5L电饭煲小型宿舍家用2人迷你多功能
                          全自动大容量
                        </div>
                        <div class="con_ge">
                          <i>颜色：棕色</i>
                          <em>规格：1-2人用小饭煲(机械型)</em>
                        </div>
                      </div>
                    </li>
                    <li class="td2">￥798.00</li>
                    <li class="td3">×2</li>
                  </ul>
                  <div class="item_bottom">
                    <div class="order_time">
                      <i>交易时间：2021-09-09 09:04:21</i>
                    </div>
                    <div class="order_state">
                      <div class="order_text">共2件商品，实付金额：</div>
                      <div class="order_pend">
                        <em>￥798.00</em>
                        <div class="pend_btn">确认收货</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="待评价" name="4">
                <div class="order_item">
                  <div class="item_title">
                    <i>订单号：2021083100011174</i>
                    <em>待评价</em>
                  </div>
                  <ul class="item_body">
                    <li class="td1">
                      <img class="body_img" src="" alt="" />
                      <div class="body_con">
                        <div class="con_title">
                          九阳电饭锅1L3L5L电饭煲小型宿舍家用2人迷你多功能
                          全自动大容量
                        </div>
                        <div class="con_ge">
                          <i>颜色：棕色</i>
                          <em>规格：1-2人用小饭煲(机械型)</em>
                        </div>
                      </div>
                    </li>
                    <li class="td2">￥798.00</li>
                    <li class="td3">×2</li>
                  </ul>
                  <div class="item_bottom">
                    <div class="order_time">
                      <i>交易时间：2021-09-09 09:04:21</i>
                    </div>
                    <div class="order_state">
                      <div class="order_text">共2件商品，实付金额：</div>
                      <div class="order_pend">
                        <em>￥798.00</em>
                        <div class="pend_btn">去评价</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="退换货" name="5">退换货</el-tab-pane>
            </el-tabs> -->
</template>
<script>
import crumb from '../components/bread-crumb/Index.vue'
export default {
  name: '产品中心',
  components: {
    crumb
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0 0;
}
</style>
